<template>
  <transition name="modal-fade">
    <div class="modal-overlay" @click.self="close">
      <div class="modal-box">

        <!-- Header -->
        <div class="modal-hdr">
          <div class="modal-hdr__icon"><i class="fa fa-shield"></i></div>
          <div class="modal-hdr__text">
            <div class="modal-hdr__title">{{ is_edit ? 'Edit Role' : 'Add Role' }}</div>
            <div class="modal-hdr__sub">{{ is_edit ? 'Update the role name' : 'Create a new system role' }}</div>
          </div>
          <button class="modal-close" @click="close"><i class="fa fa-times"></i></button>
        </div>

        <!-- Body -->
        <div class="modal-body">
          <div class="field-group" :class="{ 'field-group--error': errors['title'] }">
            <label class="field-label">Role Name <span class="req">*</span></label>
            <input
              v-model="role.title"
              type="text"
              class="field-input"
              placeholder="e.g. Manager"
              autofocus
            />
            <span class="field-error" v-if="errors['title']">{{ errors['title'][0] }}</span>
          </div>
        </div>

        <!-- Footer -->
        <div class="modal-ftr">
          <button class="ftr-cancel" @click="close">Cancel</button>
          <button class="ftr-save" @click="save">
            <i class="fa fa-check"></i> {{ is_edit ? 'Update' : 'Save' }}
          </button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import { CREATE_ROLE } from "@/core/services/store/actions.type";

export default {
  props: {
    showModal: { type: Boolean, default: false },
    is_edit:   { type: Boolean, default: false },
    role: {
      type: Object,
      default: () => ({ title: "", id: 0 }),
    },
  },
  data() {
    return { errors: [] };
  },
  methods: {
    close() {
      this.$emit("closemodal");
    },
    save() {
      this.$store.dispatch(CREATE_ROLE, this.role)
        .then(() => {
          this.$toastr.s(this.is_edit ? "Role successfully updated" : "Role successfully created");
          this.$emit("closemodal");
        })
        .catch(err => { this.errors = err; });
    },
  },
};
</script>

<style lang="scss" scoped>
$font:   'Segoe UI', sans-serif;
$blue:   #389ad4;
$dark:   #0d1b3e;
$border: #dde2ec;

.modal-overlay {
  position: fixed; inset: 0; z-index: 1050;
  background: rgba(13,27,62,0.45); backdrop-filter: blur(4px);
  display: flex; align-items: center; justify-content: center; padding: 16px;
}

.modal-box {
  background: #fff; border-radius: 16px;
  width: 100%; max-width: 420px;
  box-shadow: 0 24px 64px rgba(13,27,62,0.22); overflow: hidden;
}

.modal-hdr {
  display: flex; align-items: center; gap: 12px;
  padding: 18px 20px; border-bottom: 1px solid $border;
  background: linear-gradient(135deg, #f8faff 0%, #f0f5ff 100%);

  &__icon {
    width: 40px; height: 40px; border-radius: 10px;
    background: linear-gradient(135deg, $blue, #2277aa);
    display: flex; align-items: center; justify-content: center;
    color: #fff; font-size: 16px; flex-shrink: 0;
  }
  &__text  { flex: 1; }
  &__title { font-size: 15px; font-weight: 700; color: $dark; line-height: 1.2; }
  &__sub   { font-size: 12px; color: #7a8499; margin-top: 2px; }
}

.modal-close {
  width: 30px; height: 30px; border-radius: 7px;
  border: none; background: transparent; color: #a0aab8;
  font-size: 14px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s;
  &:hover { background: #f0f3fa; color: $dark; }
}

.modal-body {
  padding: 22px 20px;
}

.field-group {
  display: flex; flex-direction: column; gap: 5px;
  &--error .field-input { border-color: #b42318; }
}

.field-label {
  font-size: 11px; font-weight: 600;
  text-transform: uppercase; letter-spacing: 0.04em;
  color: #5a6278; font-family: $font;
  .req { color: #b42318; margin-left: 1px; }
}

.field-input {
  height: 38px;
  border: 1.5px solid $border; border-radius: 8px;
  padding: 0 11px; font-size: 13px;
  color: $dark; font-family: $font;
  outline: none; background: #fff; width: 100%;
  transition: border-color 0.2s, box-shadow 0.2s;
  box-sizing: border-box;

  &:focus { border-color: $blue; box-shadow: 0 0 0 3px rgba(56,154,212,0.1); }
  &::placeholder { color: #b0bac9; }
}

.field-error { font-size: 11px; color: #b42318; }

.modal-ftr {
  display: flex; justify-content: flex-end; gap: 10px;
  padding: 14px 20px; border-top: 1px solid $border; background: #fafbfd;
}

.ftr-cancel {
  height: 36px; padding: 0 18px; border-radius: 8px;
  border: 1.5px solid $border; background: #fff;
  color: $dark; font-size: 13px; font-weight: 600;
  font-family: $font; cursor: pointer;
  transition: background 0.15s;
  &:hover { background: #f4f6fb; }
}

.ftr-save {
  height: 36px; padding: 0 20px; border-radius: 8px;
  border: none; background: $blue; color: #fff;
  font-size: 13px; font-weight: 600; font-family: $font;
  cursor: pointer; display: inline-flex; align-items: center; gap: 6px;
  transition: background 0.15s, box-shadow 0.15s;
  &:hover { background: #2d85bb; box-shadow: 0 4px 12px rgba(56,154,212,0.35); }
  i { font-size: 12px; }
}

.modal-fade-enter-active, .modal-fade-leave-active { transition: opacity 0.2s; }
.modal-fade-enter, .modal-fade-leave-to { opacity: 0; }
</style>
